/*
*###############################################################################
*Module Name                   : DPButton.js                                   #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Saturday, July 24th 2021, 2:01:21 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/



import React, { useState } from "react";
import {Button}  from "reactstrap";

const DPButton = (props)=>{

    const Configs = {
        buttons: "round",
        toolBarButtons: "round",
        toolBarIconType: "mdi",
        toolBarIconPlace: "left",
        height: 23,
        handleDiameter: 15
    }

//Customization Parameter
 const btnType = Configs.buttons

 switch (btnType) {
     case "default":
        return <DefaultButton color={props.color} text={props.text} onClick={props.onClick} size={props.size} width={props.width} block={props.block}/>
    case "outline":
        return <OutLineButton color={props.color} text={props.text} onClick={props.onClick} size={props.size} width={props.width} block={props.block}/>
    case "round":
        return <RoundButton color={props.color} text={props.text} onClick={props.onClick} size={props.size}  width={props.width} block={props.block}/>
        
 }
    
}

export default  DPButton;

const DefaultButton = (props) =>{

//Style class
    var classNames = 'btn btn-'+props.color +' '+ (props.size != null ? "btn-"+props.size : "") + ' ' + (props.width != null ? "w-"+props.width : "") + ' ' + (props.block != null ? "btn-block" : "");

    return(
        <Button
            color= {props.color}
            className={classNames}
            onClick={props.onClick}
        >
            {props.text}
        </Button>
    );
}

const OutLineButton = (props) =>{
//Style class
    var classNames = (props.size != null ? "btn-"+props.size : "")+ ' ' + (props.width != null ? "w-"+props.width : "") + ' ' + (props.block != null ? "btn-block" : "");

    return(
        <Button
            color= {props.color}
            outline
            className={classNames}
            onClick={props.onClick}
        >
            {props.text}
        </Button>
    );
}

const RoundButton = (props) =>{
    //Style class
        var classNames = 'btn-rounded ' + (props.size != null ? "btn-"+props.size : "") + ' ' + (props.width != null ? "w-"+props.width : "") + ' ' + (props.block != null ? "btn-block" : "");
    
        return(
            <Button
                color= {props.color}
                className={classNames}
                onClick={props.onClick}
            >
                {props.text}
            </Button>
        );
}